import React, {Component, Fragment, PureComponent, useCallback, useEffect, useState, Linking} from 'react';

import {WingBlank, Icon, List, NoticeBar, SegmentedControl, Toast, Modal} from 'antd-mobile';
import PublicHeader from './../../components/header/index';
import {createOrder, getDetailInfo, getSiteList, getVenueDetail, getVenueList} from './store/actionCreators';
import {connect} from 'react-redux';
import styles from './index.scss';
import history from './../../utils/history';

const Item = List.Item;

const alert = Modal.alert;

function SpaceSelect(props) {

    const [spaceTitle, setSpaceTitle] = useState([])
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [spaceTitleDetail, setSpaceTitleDetail] = useState([])
    const [siteInfos, setSiteInfos] = useState([])
    const [forceUpdate, setForceUpdate] = useState(0);
    const [itemUpdate, setItemUpdate] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0)

    const [hidden, setHidden] = useState("");
    const [siteList, setSiteList] = useState([])

    const [selectPricelist, setSelectPricelist] = useState([])

    const [needFixed, setNeedFixed] = useState(false);

    async function loadData() {
        Toast.loading('加载中...', 3, () => {
            Toast.hide();
        });

        var userInfo = Storage.Base.getInstance().get('_loginTk');
        if (userInfo === null) {
            history.push('./login');
            return;
        }

        var spaceTitles = [];
        var spaceTitleDetails = [];
        var venueId = props.events.location.state.id;
        var date = props.events.location.state.date;
        var type = props.events.location.state.type;
        const venueInfo = await props.events.getVenueDetail(venueId);

        const venueInfos = venueInfo.value;
        const {specialChargeTitleDTO = []} = venueInfos;

        specialChargeTitleDTO.map((item, index) => {
            var spaceTitle = {}
            spaceTitle.selectedIndex = index;
            spaceTitle.tile = item.week + item.strDate;
            spaceTitle.week = item.week;
            spaceTitle.date = item.mDate;
            spaceTitle.time = item.date;
            if (item.date === date) {
                setSelectedIndex(index)
            }
            spaceTitleDetails.push(spaceTitle);
            spaceTitles.push(spaceTitle.tile);
        })

        const venueDetailInfo = await props.events.getDetailInfo(venueId, date, type);
        const {siteInfos = []} = venueDetailInfo.value;
        Toast.hide();
        var sitesList = [];
        siteInfos.map((item, index) => {
            var sitesDetail = {};
            sitesDetail.id = item.id;
            sitesDetail.name = item.name;
            const {spacePrices = []} = item;
            var sitePriceList = [];
            spacePrices.map((item, index) => {
                var sitePriceDetail = {};
                sitePriceDetail.siteId = sitesDetail.id;
                sitePriceDetail.seq = item.seq;
                sitePriceDetail.price = item.price;
                sitePriceDetail.select = false;
                sitePriceDetail.beginTime = item.beginTime;
                sitePriceDetail.endTime = item.endTime;
                sitePriceDetail.index = index;
                sitePriceDetail.status = item.status;
                sitePriceList.push(sitePriceDetail);
            })
            sitesDetail.priceList = sitePriceList;
            sitesList.push(sitesDetail);
        })
        setSpaceTitleDetail(spaceTitleDetails)
        setSpaceTitle(spaceTitles);
        setSiteInfos(siteInfos)
        setSiteList(sitesList);
        setTotalPrice(0)
        Toast.hide();

        window.addEventListener('scroll', handleScroll, true);
    }


    function handleScroll(event) {
        if (document.getElementById("selectTimes").scrollTop) {
            var scrollTop = document.getElementById("selectTimes").scrollTop;
            console.log("scroll", scrollTop);
            if (scrollTop > 100) {
                setNeedFixed(true);
            }
            else {
                setNeedFixed(false);
            }

            setNeedFixed(false);
        }
    }

    function HandleSubmitOrder() {
        Toast.loading('预定中...', 10, () => {
        });
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }
        let price = totalPrice;
        // if (price <= 0) {
        //     Toast.show("请选择时间段！")
        //     return;
        // }

        let selectdProducts = [];
        siteList.map((item, index) => {
            var skus = [];
            var productDetail = {};
            productDetail.userId = oauthInfo.id;
            productDetail.siteId = item.id;
            item.priceList.map((detail, index) => {
                if (detail.select) {
                    let productItem = {};
                    productItem.siteId = detail.siteId;
                    productItem.seq = detail.seq;
                    productItem.beginTime = detail.beginTime;
                    productItem.endTime = detail.endTime;
                    skus.push(productItem);
                }
            })
            productDetail.skus = skus;
            if (skus.length !== 0) {
                selectdProducts.push(productDetail);
            }
        })
        if (selectdProducts.length !== 1) {
            Toast.show("暂不支持跨场次选择时间段！请重新选择。")
            return;
        }
        // if (selectdProducts[0].skus.length === 1) {
        //     Toast.show("至少选择两个连续时间段。")
        //     return;
        // }
        Toast.hide();
        history.push("/pay", {products: selectdProducts[0]});
        //props.events.createOrder(selectdProducts[0]);

    }

    function onChange(e) {
        let selectedIndex = e.nativeEvent.selectedSegmentIndex;
        var spaceTitle = spaceTitleDetail[selectedIndex]
        var venueId = props.events.location.state.id;
        var type = props.events.location.state.type;
        setForceUpdate(Math.random())
        history.replace("/spaceDetail", {date: spaceTitle.time, id: venueId, type: type});
    }

    function clickItem(value) {
        siteList.map((item, index) => {
            const {priceList = []} = item;
            priceList.map((priceItem, index) => {
                if (priceItem.seq === value.seq && priceItem.siteId === value.siteId) {
                    if (priceItem.select) {
                        priceItem.select = false;
                        setTotalPrice((prevCartTotalPrice) => (
                            prevCartTotalPrice -= priceItem.price
                        ));
                    } else {
                        priceItem.select = true;
                        setTotalPrice((prevCartTotalPrice) => (
                            prevCartTotalPrice += priceItem.price
                        ));
                    }
                }
            })
        })
        setSiteList(siteList);
        setItemUpdate(Math.random())
    }

    useEffect(() => {
        loadData();
    }, [forceUpdate]);

    //
    // useEffect(() => {
    //     loadData();
    // }, []);

    useEffect(() => {
    }, [itemUpdate]);


    return (
        <Fragment>
            <SegmentedControl
                id="title_space"
                className="title_space"
                values={spaceTitle}
                style={{textAlign: "center", margin: "10px 0"}}
                selectedIndex={selectedIndex}
                onChange={onChange}
                onScroll={() => {
                }}
            />
            <div className="selectDay"
                 onScroll={() => {
                 }}>
                <div className="selectTimes" id="selectTimes">
                    <div style={{width: "10000px", paddingLeft: "62px",}}>
                        {siteList.map((item, index) => {
                                const {priceList = []} = item;
                                return (
                                    <dl id={item.id} key={index}>
                                        <dt id="changdi"
                                            className={needFixed ? "a-fixed" : "changdi"}>{item.name}</dt>
                                        {priceList.map((item, index) => {
                                            return (
                                                item.price >= 0 && item.status === 0 ?
                                                    <dd className="vv_sel"
                                                        key={index}
                                                        style={item.select ? {
                                                            backgroundColor: "#68AEFF",
                                                            color: "#FFFFFF"
                                                        } : {}}
                                                        onClick={() => {
                                                            //item.select = true;
                                                            clickItem(item)
                                                        }}>
                                                        ￥{item.price / 100}
                                                    </dd>
                                                    :
                                                    <dd className="vv_sel" key={index}
                                                        style={{backgroundColor: "#eee"}}></dd>
                                            )
                                        })
                                        }
                                    </dl>
                                )
                            }
                        )}

                    </div>
                    <div className="selectNom">
                        <div style={{height: "49px"}}></div>
                        <em>09:00</em>
                        <em>10:00</em>
                        <em>11:00</em>
                        <em>12:00</em>
                        <em>13:00</em>
                        <em>14:00</em>
                        <em>15:00</em>
                        <em>16:00</em>
                        <em>17:00</em>
                        <em>18:00</em>
                        <em>19:00</em>
                        <em>20:00</em>
                        <em>21:00</em>
                        <em>22:00</em>
                    </div>
                </div>
            </div>

            <div className="detail_bottom" style={{display: {hidden}}}>
                <div className="signal">
                    <div className="signal_Img" id="signal_Img">
                      <span>
                         <div className="wodeyuding"></div>
                        <p>已选择</p>
                      </span>
                        <span>
                         <div className="keyiding"></div>
                         <p>可预订</p>
                      </span>
                        <span>
                         <div className="yishouwan"></div>
                         <p>已售完</p>
                      </span>
                    </div>
                    <div className="signal_venues">
                        <div id="haveChoose">


                        </div>
                    </div>
                </div>
            </div>
            <div className="art-order-detail__footer">
                <div>合计: <span>￥{totalPrice / 100}</span></div>
                <div onClick={HandleSubmitOrder}>
                    立即预订
                </div>
            </div>
        </Fragment>
    )
}


const SpaceDetail = (props) => {
    return (
        <Fragment>
            <PublicHeader title="场地预定"/>
            <NoticeBar mode="closable" icon={<Icon type="check-circle-o" size="xxs"/>}>
                请选择连续时间段,暂不支持跨时间段预订!
            </NoticeBar>
            <SpaceSelect events={props}/>
        </Fragment>
    )
}

const mapStateToProps = (venue) => {
    return {
        venueInfo: venue.venue.venueInfo
    }
};

const mapDispatchToProps = (dispatch) => ({
    getVenueDetail: (id) => dispatch(getVenueDetail(id)),
    getSiteList: (id) => dispatch(getSiteList(id)),
    createOrder: (param) => dispatch(createOrder(param)),
    getDetailInfo: (id, time, type) => dispatch(getDetailInfo({
        venueId: id,
        time: time,
        type: type
    })),
});

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(SpaceDetail));
